import React from 'react'
import { YStack, styled, useThemeName, isWeb, useMedia } from 'tamagui'

import { usePalette } from './Palette/PaletteContext'

const CardBase = styled(YStack, {
  name: 'Card',
  borderRadius: '$6',
  backgroundColor: '$backgroundSoft',
  // @ts-expect-error - boxShadow is a web-only property
  boxShadow: '$boxShadowLight',

  padding: '$5',

  variants: {
    main: {
      true: {
        tag: 'main',
      },
    },
  } as const,
} as const)

type CardProps = React.ComponentProps<typeof CardBase> & { glass?: boolean }

export const Card = ({ glass, style, ...props }: CardProps) => {
  const { palette } = usePalette()
  const themeName = useThemeName()
  const isDark = themeName.startsWith('dark')
  const { reducedMotion: reducedEffects } = useMedia()

  if (!glass || !isWeb || !palette) {
    return <CardBase style={style} {...props} />
  }

  const glassBackground = palette.glassBackground

  return (
    <CardBase
      {...props}
      backgroundColor='transparent'
      // style prop accepts web CSS properties on web
      style={{
        backgroundColor: glassBackground,
        ...(reducedEffects ? {} : {
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
        }),
        ...(typeof style === 'object' ? style : {}),
      }}
    />
  )
}
